import Color from 'color';

export const getBrandColors = (colors) => [
  {
    label: __('Primary'),
    value: Color(colors.button_primary ?? colors.primary)
      .hex()
      .toLowerCase(),
  },
  {
    label: __('Header'),
    value: Color(colors.header).hex().toLowerCase(),
  },
  {
    label: __('Focus'),
    value: Color(colors.focus).hex().toLowerCase(),
  },
];
